import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=f89aacd6&scoped=true"
import script from "./Popover.vue?vue&type=script&lang=js"
export * from "./Popover.vue?vue&type=script&lang=js"
import style0 from "./Popover.vue?vue&type=style&index=0&id=f89aacd6&prod&lang=scss"
import style1 from "./Popover.vue?vue&type=style&index=1&id=f89aacd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89aacd6",
  null
  
)

export default component.exports